export const SET_CENTROS_CUSTOS_ACTION = 'centrosCustos';
export const SET_SOLICITANTES_ACTION = 'solicitantes';
export const SET_PRODUTO_ACTION = 'produto';
export const SET_PROJETO_ACTION = 'projeto';
export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_EMPRESA_ACTION = 'empresa';
export const SET_LOCAL_ENTREGA_ACTION = 'localEntrega';
export const SET_GRUPO_ACTION = 'grupo';
export const SET_DATA_INICIAL_ACTION = 'dataInicial';
export const SET_DATA_FINAL_ACTION = 'dataFinal';
export const SET_DATA_ENTREGA_INICIAL_ACTION = 'dataEntregaInicial';
export const SET_DATA_ENTREGA_FINAL_ACTION = 'dataEntregaFinal';
export const SET_URGENCIA_ACTION = 'urgencia';
export const SET_SHOW_ESPECIFICACAO_ACTION = 'showEspecificacao';
export const SET_SHOW_OBSERVACAO_EXTERNA_ACTION = 'showObservacaoExterna';
export const SET_SHOW_OBSERVACAO_INTERNA_ACTION = 'showObservacaoInterna';
export const SET_COMPRADORES_ACTION = 'compradores';
export const SET_FILTER_ACTION = 'filter';
export const SET_LIST_OPTIONS_ACTION = 'listOptions';
export const RESET_PAGINATION = 'resetPagination';
export const INIT_STATE_ACTION = 'initState';
export const SET_CURRENT_SESSION_STATE_ACTION = 'sessionState';
